import { render, staticRenderFns } from "./RefereeDetail.vue?vue&type=template&id=61328bbe&"
import script from "./RefereeDetail.vue?vue&type=script&lang=js&"
export * from "./RefereeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports